import addNamespaces from '../translations/add-namespaces';
import en from '../translations/components/en.json';
import nl from '../translations/components/nl.json';

addNamespaces('components', { en, nl });
